import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EmailConfirmedInterceptor } from 'src/app/core/interceptor/email-confirmed.interceptor';
import { HttpInternalService } from 'src/app/data/service/http.service';
import { AnalyticsService } from 'src/app/core/service/analytics/analytics.service';

// SD-1137: Modal that opens whenever the HTTP interceptor sees a 403 with body
// { error: "email_not_confirmed" }. Placed once at the app shell level; does not
// need to be routed. Same resend flow as the banner.
@Component({
  selector: 'app-verification-required-modal',
  templateUrl: './verification-required-modal.component.html',
  styleUrls: ['./verification-required-modal.component.scss']
})
export class VerificationRequiredModalComponent implements OnInit, OnDestroy {
  open = false;
  sending = false;
  message = '';
  private destroy$ = new Subject<void>();

  constructor(
    private http: HttpInternalService,
    private analytics: AnalyticsService
  ) {}

  ngOnInit(): void {
    EmailConfirmedInterceptor.emailNotConfirmed$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.open = true;
        this.message = '';
        this.analytics.capture('verification_required_modal_shown');
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.open = false;
  }

  resend(): void {
    const email = localStorage.getItem('Email');
    if (!email || this.sending) return;
    this.sending = true;
    this.http.postRequest<any>('Account/ResendVerificationEmail', JSON.stringify({ email }))
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.sending = false;
          this.message = res?.status === 0
            ? 'Verification email sent.'
            : (res?.message || 'Failed to resend.');
          this.analytics.capture('verification_required_modal_resend_clicked');
        },
        () => {
          this.sending = false;
          this.message = 'Failed to resend.';
        }
      );
  }
}
